export default {"src":"/_next/static/media/grassroots_carbon.3fa3b2bc.svg","height":67,"width":281};